import React, { useState } from "react";

const Donate = () => {
  const [showQR, setShowQR] = useState(false);

  return (
    <section className="min-h-screen bg-gradient-to-b from-pink-50 via-white to-purple-50 py-16 px-4 md:px-12 text-center">
      <h2 className="text-4xl md:text-5xl font-bold text-pink-700 mb-6">
        Your Support Empowers a Dream 🌸
      </h2>

      <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 mb-8">
        “When women support each other, incredible things happen.”<br />
        Your small contribution can spark a movement, uplift a voice, and change a life.
      </p>

      <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 mb-8">
        “If these stories mean something to you, appreciate the effort.”<br />
        Donate a penny — every step matters.
      </p>

      {/* Support Button */}
      <div className="flex justify-center mb-10">
        <button
          onClick={() => setShowQR(true)}
          className="bg-pink-600 hover:bg-pink-700 text-white font-bold py-3 px-6 rounded-xl shadow-lg transition duration-300"
        >
          Support 💖
        </button>
      </div>

      <p className="text-gray-600 text-md md:text-lg max-w-2xl mx-auto">
        Scan the QR code using any UPI app to donate.
      </p>

      {/* QR Modal */}
      {showQR && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-xl text-center w-[90%] max-w-sm">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">
              Scan to Pay 📱
            </h3>

            <img
              src="/upi-qr.jpeg"
              alt="UPI QR"
              className="w-52 h-52 mx-auto mb-4"
            />

            <p className="text-sm text-gray-500 mb-4">
              Open any UPI app and scan this QR
            </p>

            <button
              onClick={() => setShowQR(false)}
              className="text-pink-600 hover:underline"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="mt-10 text-pink-600 font-semibold text-lg">
        “Empowered women empower the world.”<br />
        Be the spark. Be the change. Be the reason someone believes in themselves again.
      </div>
    </section>
  );
};

export default Donate;
